module.exports = __webpack_public_path__ + "images/help/icon-twr42-aa7732adc994a5b1aff6b34894cd42fe.png";